import {defineStore} from 'pinia'
import type {OutputChatChannelReadStatus} from "~/models"

export const useChatReadStatusStore = defineStore('chatReadStatus', {
    state: () => ({
        channelUnreadMessages: new Map<number, number>(),
    }),
    getters: {
        totalUnread: (state: any): number => {
            let total = 0

            for (const unreadCount of state?.channelUnreadMessages.values() || []) {
                total += unreadCount
            }

            return total
        },
        unreadByChannels: (state: any): Map<number, number> => {
            return state.channelUnreadMessages
        },
    },
    actions: {
        async load() {
            const permissionsStore = usePermissionsStore()
            if (permissionsStore.permissions.length === 0) {
                await permissionsStore.load()
            }
            if (!permissionsStore.permissions.includes('chat_page:view')) {
                return
            }

            const unreadMessages = await useApi().getChatReadStatuses()
            for (const i of unreadMessages) {
                this.channelUnreadMessages.set(i.channelId, i.unreadCount)
            }
        },

        handleCentrifugeNotification(message: {
            type: string,
            payload: OutputChatChannelReadStatus
        }) {
            // Якщо прийшло щось інше, не обробляємо
            if (!message || message.type !== 'chat_unread_count') {
                return
            }

            this.channelUnreadMessages.set(
                message.payload.channelId,
                message.payload.unreadCount
            )
        }
    },
})